import { KeyValueInterface, ProductSpecificatieInterface } from '../../models/interfaces/smart.interface';

import { EnvService } from '../../environments/environment.factory';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { prepareAuthHeaders } from '../headers';

@Injectable()
export class SmartProvider {

  private environment: any;

  constructor(
    private http: HttpClient,
    private env: EnvService
  ) {
    this.environment = env;
  }

  public getHandelingen(): Observable<{ data: KeyValueInterface[] }> {
    const headers = prepareAuthHeaders();
    return this.http.get<{ data: KeyValueInterface[] }>(`${this.environment.api}/v1/smart/handelingen`, { headers });
  }

  public getBevestigingsmethoden(): Observable<{ data: KeyValueInterface[] }> {
    const headers = prepareAuthHeaders();
    return this.http.get<{ data: KeyValueInterface[] }>(`${this.environment.api}/v1/smart/bevestigingsmethoden`, { headers });
  }

  public getProductSpecificaties(): Observable<{ data: KeyValueInterface[] }> {
    const headers = prepareAuthHeaders();
    return this.http.get<{ data: KeyValueInterface[] }>(`${this.environment.api}/v1/smart/product-specificaties`, { headers });
  }

  public getProductSpecificatie(product_id: string): Observable<{ data: ProductSpecificatieInterface }> {
    const headers = prepareAuthHeaders();
    return this.http.get<{ data: ProductSpecificatieInterface }>(`${this.environment.api}/v1/smart/product-specificatie/${product_id}`, { headers });
  }

  public getVragen(params: {}): Observable<{ data: { vraag: string, antwoord: string }[] }> {
    const urlParams = '?' + Object.keys(params)
      .map(function (prop) {
        return [prop, params[prop]].map(encodeURIComponent).join("=");
      })
      .join("&");
    const headers = prepareAuthHeaders();
    return this.http.get<{ data: { vraag: string, antwoord: string }[] }>(`${this.environment.api}/v1/smart/vragen/${urlParams}`, { headers });
  }

  public postBron(project_id: number, bron_id: number): Observable<{ data: any }> {
    const headers = prepareAuthHeaders();
    return this.http.post<{ data: any }>(`${this.environment.api}/v1/smart/bron/${project_id}/${bron_id}`, {}, { headers });
  }
}



// WEBPACK FOOTER //
// ./src/providers/smart/smart.ts